import { Autocomplete, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormHelperText, Grid, TextareaAutosize, TextField, Tooltip } from '@mui/material'
import ButtonComponent from '../shared/button/button.component'
import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors";
import { Contact, ConversationModel, Type } from '../../models/conversations';
import { PhoneNumberModel } from '../../models/phone-number.model';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { MessageService } from '../../services/MessageService';
import { LocalStorage, UtilityService } from '../../services/UtilityService';
import { ProfileModel } from '../../models/profile.model';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { AutomationRulesLabel, Tags, ToasterTexts } from '../shared/constants';
import { BackMobileIcon, CancelIcon } from '../../icon';
import { validateForm } from '../shared/form-validation';
import MediaComponent from '../shared/media/media.component';
import MentionComponent from '../shared/mentions';
import { UserModel } from '../../models/users.model';
import { UserService } from '../../services/UserService';

interface Props {
    Show: boolean;
    HandleCloseTransfer: () => void;
    ContactNumber: string
}

const TransferConversationChat = ({ Show, HandleCloseTransfer, ContactNumber }: Props) => {
    const innerRef = useRef<any>();

    const Contacts: Contact[] = useSelector(selector.contacts);
    const AllUsers: UserModel[] = useSelector(selector.allUsers);
    const History: { [key: string]: ConversationModel[] } = useSelector(selector.history);
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const [selectedPhoneNumber, setSelectedPhoneNumber] = useState<PhoneNumberModel>();
    const [historyPhonenumber, setHistoryPhonenumber] = useState<ConversationModel[]>([]);
    const [selectedMessages, setSelectedMessages] = useState<string[]>([]);
    const [customMessage, setCustomMessage] = useState<string>('');
    const [Loading, setLoading] = useState<boolean>(false);
    const [Profile, setProfile] = useState<ProfileModel>(UserService.getCurrentUserFromLocalStorage())

    const [errors, seterrors] = useState({
        phoneNumber: "",
        history: "",
    });
    const location = useLocation();

    const handleToggle = (id: string) => {
        setSelectedMessages((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    useEffect(() => {
        let pathName = location.pathname
        let number = pathName?.slice(pathName.lastIndexOf("/") + 1, pathName.length)
        setHistoryPhonenumber(History[number]?.filter(x => x.Type === Type.Normal))
        setTimeout(() => { scrollToBottom() }, 100)
    }, [])

    const handleTransferChat = () => {
        if (validateForm({ phonenumber: selectedPhoneNumber?.PhoneNumber, tranferchatmessages: selectedMessages }, (Errors) => {
            seterrors({ ...errors, phoneNumber: Errors.phonenumber, history: Errors.tranferchatmessages })
        })) {

            let selectedmsgs = historyPhonenumber?.filter(x => selectedMessages.includes(x.ID))?.sort((a, b) => new Date(a.MessageDateTime).getTime() - new Date(b.MessageDateTime).getTime());
            const data = {
                "fromPhoneNumber": Profile.PhoneNumber,
                "contactNumber": ContactNumber,
                "toPhoneNumber": selectedPhoneNumber?.PhoneNumber,
                "contextMessage": customMessage,
                "conversationHistoryIds": selectedmsgs?.map(x => x.ID),
                "userId": LocalStorage.get("current-user")?.id,
                "toPhoneNumberId": selectedPhoneNumber.ID
            }
            setLoading(true)
            MessageService.TransferChat(data)
                .then((res) => {
                    setLoading(false)
                    HandleCloseTransfer()
                }).catch(err => {
                    setLoading(false)
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                })
        }
    }

    const getUserName = (senderId: string) => {
        let data = AllUsers.find((x) => x.ID === senderId);
        if (data) {
            let name = data.FirstName + " " + data.LastName.charAt(0).toUpperCase() + data.LastName.slice(1).toLowerCase();
            return UtilityService.trimMessage(name, 20)
        }
        else if (senderId === AutomationRulesLabel.SENDERID) {
            return AutomationRulesLabel.AUTOMATED_REPLY
        }
    }

    const getGroupChatUserName = (number: string) => {
        var data = Contacts.find((x) => x.PhoneNumber === number);
        if (!!data) {
            let name = data?.Name;
            return UtilityService.trimMessage(name, 17)
        }
        else if (data === undefined) {
            return UtilityService.maskPhoneNumberOnLength(number)
        }
    }

    const scrollToBottom = () => {
        const { current } = innerRef;
        if (!!current) {
            requestAnimationFrame(() => {
                current.scrollTop = current.scrollHeight
            })
        }
    }

    return (
        <>
            {
                IsMobileDevice ?
                    <div className='paper-background o-x-hidden w-fill h-v-100'>
                        <Grid item xs={12} className=''>
                            <div className='box-shadow-display-background-shadow d-flex p-2'>
                                {IsMobileDevice && <span><BackMobileIcon className={"c-pointer pr-2"} onClick={() => HandleCloseTransfer()} /></span>}
                                <span className={`h1 my-auto color-add-details-title mr-auto`}>
                                    {"Transfer Chat"}
                                </span>
                            </div>
                        </Grid>
                        <Autocomplete
                            size="small"
                            className='px-2 mt-1'
                            classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                            options={PhoneNumbers}
                            getOptionLabel={(option) => `${option?.Name} - ${option?.PhoneNumber || ''}`}
                            disableClearable
                            isOptionEqualToValue={(option, value) => option?.ID === value?.ID || option?.Name === value?.Name}
                            onChange={(event: any, value: PhoneNumberModel | null) => {
                                setSelectedPhoneNumber(value);
                            }}
                            value={selectedPhoneNumber}
                            renderOption={(props, option: PhoneNumberModel, { selected }) => (
                                <li {...props} className={`${props.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                    <div className='d-flex justify-between w-p-100'>
                                        <div>{option?.Name}</div>
                                        <div className="">{option?.PhoneNumber || ''}</div>
                                    </div>
                                </li>
                            )}
                            disabled={false}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    label="Select Phone Number"
                                    name="PhoneNumber"
                                    placeholder="Choose a phone number"
                                    required
                                    variant="outlined"
                                />
                            }
                        />
                        <FormHelperText className="h5 color-primary-danger t-align-right mr-1 px-2">
                            {errors.phoneNumber}
                        </FormHelperText>
                        <div className=" br-1 o-y-scroll h-p-60 d-flex flex-direction border-primary-divider mt-1 mx-2"
                            ref={innerRef}>
                            {historyPhonenumber?.map((history) => (
                                <div key={history.ID} className=" d-flex align-center py-1">
                                    <div className=" w-p-5 px-1">
                                        <Checkbox
                                            className='p-0 d-flex justify-center'
                                            checked={selectedMessages.includes(history.ID)}
                                            classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                            onChange={() => handleToggle(history.ID)}
                                        />
                                    </div>

                                    <div className={`d-flex w-p-100 ${history.IsOutbound ? "justify-flex-end " : "justify-flex-start "}`}>
                                        <div className={`w-p-50 p-1 br-1 w-break h4-regular ${history.IsOutbound ? " bg-color-con-hist-outbound-msg-bg" : " bg-color-con-hist-inbound-msg-bg"}`}>
                                            <div className={` ${history.IsOutbound ? "d-flex justify-flex-end" : ""} color-conversation-history-msg footnote`}>{UtilityService.convertToDateTimeFormat(history.MessageDateTime)}</div>
                                            {!!history?.Media && history?.Media?.map(Media => <MediaComponent Media={Media} NoDownloadOption={false} SenderName={history.IsOutbound ? getUserName(history.SenderID) : getGroupChatUserName(history.FromPhoneNumber)} />)}
                                            {!!history.Message && <MentionComponent IsGroupChat={!!history.GroupChat?.ID} body={history.Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={history.Message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={history.IsOutbound} IsLinkAllowed={true} />}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='d-flex flex-direction pt-1 px-2'>
                            <TextareaAutosize
                                onChange={(e) => setCustomMessage(e.target.value)}
                                minRows={3} placeholder="Internal Note (Visible only to the other agent)"
                                className='border-primary-divider br-1'
                            />
                        </div>
                        <div className="d-flex my-2 px-2 mt-auto w-p-100 mr-0 justify-flex-end mr-2">
                            <ButtonComponent ButtonLabel='Transfer' Variant={'primary-btn-small'} OnClick={handleTransferChat} Loading={Loading} />
                            <ButtonComponent ButtonLabel='Cancel' Variant={'secondary-btn-small'} OnClick={HandleCloseTransfer} ClassName='mr-4 ml-2' />
                        </div>
                    </div> :

                    <Dialog
                        fullWidth
                        maxWidth="sm"
                        open={Show}
                        className='h-p-100'
                    >
                        <DialogTitle className='d-flex justify-between px-3 pb-0'>
                            <span> Transfer Chat</span>
                            <Tooltip title='Close' placement='bottom'><CancelIcon className={`c-pointer mr-1`} onClick={() => HandleCloseTransfer()} /></Tooltip>
                        </DialogTitle>

                        <DialogContent className='py-1 h-v-65 w-p-92 d-flex flex-direction justify-center'>
                            <Autocomplete
                                size="small"
                                classes={{ input: 'h4-regular color-text-field-font', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={PhoneNumbers}
                                getOptionLabel={(option) => `${option?.Name} - ${option?.PhoneNumber || ''}`}
                                disableClearable
                                isOptionEqualToValue={(option, value) => option?.ID === value?.ID || option?.Name === value?.Name}
                                onChange={(event: any, value: PhoneNumberModel | null) => {
                                    setSelectedPhoneNumber(value);
                                }}
                                value={selectedPhoneNumber}
                                renderOption={(props, option: PhoneNumberModel, { selected }) => (
                                    <li {...props} className={`${props.className} c-pointer h4-regular color-menu-list-font-color p-2 d-flex justify-between ${selected ? 'Mui-focused' : ''}`}>
                                        <div className='d-flex justify-between w-p-100'>
                                            <div>{option?.Name}</div>
                                            <div className="">{option?.PhoneNumber || ''}</div>
                                        </div>
                                    </li>
                                )}
                                disabled={false}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        label="Select Phone Number"
                                        name="PhoneNumber"
                                        placeholder="Choose a phone number"
                                        required
                                        variant="outlined"
                                    />
                                }
                            />
                            <FormHelperText className="h5 color-primary-danger t-align-right mr-1">
                                {errors.phoneNumber}
                            </FormHelperText>
                            <div className=" br-1 o-y-scroll h-p-75 d-flex flex-direction border-primary-divider mt-1" ref={innerRef}>
                                {historyPhonenumber?.map((history) => (
                                    <div key={history.ID} className=" d-flex align-center py-1">
                                        <div className=" w-p-5">
                                            <Checkbox
                                                className='p-0 d-flex justify-center'
                                                checked={selectedMessages.includes(history.ID)}
                                                classes={{ checked: "selected-checkbox", indeterminate: "selected-checkbox" }}
                                                onChange={() => handleToggle(history.ID)}
                                            />
                                        </div>

                                        <div className={`d-flex w-p-100 ${history.IsOutbound ? "justify-flex-end " : "justify-flex-start "}`}>
                                            <div className={`w-p-50 p-1 br-1 w-break h4-regular ${history.IsOutbound ? " bg-color-con-hist-outbound-msg-bg" : " bg-color-con-hist-inbound-msg-bg"}`}>
                                                <div className={` ${history.IsOutbound ? "d-flex justify-flex-end" : ""} color-conversation-history-msg footnote`}>{UtilityService.convertToDateTimeFormat(history.MessageDateTime)}</div>
                                                {!!history?.Media && history?.Media?.map(Media => <MediaComponent Media={Media} NoDownloadOption={false} SenderName={history.IsOutbound ? getUserName(history.SenderID) : getGroupChatUserName(history.FromPhoneNumber)} />)}
                                                {!!history?.Message && <MentionComponent IsGroupChat={!!history.GroupChat?.ID} body={history.Message} tags={Tags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={history.Message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={history.IsOutbound} IsLinkAllowed={true} />}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <FormHelperText className="h5 color-primary-danger t-align-right mr-1 px-2">
                                {errors.history}
                            </FormHelperText>
                            <div className='d-flex flex-direction pt-1'>
                                <TextareaAutosize
                                    onChange={(e) => setCustomMessage(e.target.value)}
                                    minRows={3}
                                    placeholder="Internal Note (Visible only to the other agent)"
                                    className='border-primary-divider br-1 bg-color-primary-background color-primary-accent'
                                />
                            </div>
                        </DialogContent>

                        <DialogActions>
                            <ButtonComponent ButtonLabel='Transfer' Variant={'primary-btn-small'} OnClick={handleTransferChat} Loading={Loading} />
                            <ButtonComponent ButtonLabel='Cancel' Variant={'secondary-btn-small'} OnClick={HandleCloseTransfer} />
                        </DialogActions>
                    </Dialog>
            }
        </>
    )
}

export default TransferConversationChat